import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Hero } from "../components/sections/Hero";
import { Marquee } from "../components/sections/Marquee";
import { Capabilities } from "../components/sections/Capabilities";
import { Collections } from "../components/sections/Collections";
import { Atelier } from "../components/sections/Atelier";
import { Contact } from "../components/sections/Contact";

export default function Landing() {
  return (
    <div id="top" data-testid="landing-page" className="bg-[#F9F8F6]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Capabilities />
        <Collections />
        <Atelier />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
